import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';

const styles = () => ({
  container: {
    height: 'calc(100vh - 96px - 50px)',
    flexGrow: '1',
  },
  root: {
    background: '#fff',
    height: '100%',
    margin: 'auto',
    overflow: 'auto',
    borderRadius: '12px',
  },
});

const CanvasPaper = (props) => {
  const { classes, children } = props;
  return (
    <div className={classes.container}>
      <Card className={classes.root} >
        {children}
      </Card>
    </div>
  );
};

CanvasPaper.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(CanvasPaper);
